import { classifyCapgoReason, stripCapgoPrefix, stripUrlQueries, type CapgoReason } from './capgoReason';

export const CAPGO_RING_SIZE = 32;
export const CAPGO_RING_MAX_AGE_MS = 120_000;
const MAX_LINE = 300;
const IPV4 = /\b\d{1,3}(?:\.\d{1,3}){3}(?::\d+)?\b/g;
const IPV6 = /\[?(?:[0-9a-f]{0,4}:){2,7}[0-9a-f]{0,4}\]?(?::\d+)?/gi;
const REASON_LINE_PREFIXES = [
  'Download error: ',
  'Error processing file: ',
  'Failed to download from: ',
  'Insufficient disk space',
];

export interface CapgoRingEntry {
  at: number;
  line: string;
}

let ring: CapgoRingEntry[] = [];

export const recordCapgoConsoleLine = (message: unknown, at: number = Date.now()): void => {
  try {
    if (typeof message !== 'string') return;
    const body = stripCapgoPrefix(message);
    if (body === null) return;
    ring.push({ at, line: stripUrlQueries(body).replace(IPV4, '<ip>').replace(IPV6, '<ip>').slice(0, MAX_LINE) });
    if (ring.length > CAPGO_RING_SIZE) ring.shift();
  } catch {
    // diagnostics must never break the console
  }
};

export const snapshotCapgoLines = (opts: { since?: number; now?: number } = {}): CapgoRingEntry[] => {
  const { since, now = Date.now() } = opts;
  return ring.filter(
    (entry) => now - entry.at <= CAPGO_RING_MAX_AGE_MS && (since === undefined || entry.at > since),
  );
};

export const lastCapgoReason = (entries: CapgoRingEntry[]): CapgoReason | undefined => {
  const reasons = entries
    .filter((entry) => REASON_LINE_PREFIXES.some((prefix) => entry.line.startsWith(prefix)))
    .map((entry) => classifyCapgoReason(entry.line));
  const real = reasons.filter((reason) => reason.reasonClass !== 'android_no_reason');
  const pool = real.length > 0 ? real : reasons;
  return pool[pool.length - 1];
};

export const clearCapgoRing = (): void => {
  ring = [];
};
